import { Flex } from "@chakra-ui/react";
import { CHAT_COLORS } from "./chatStyles";

/** Small round "AI" mark that identifies assistant messages. */
export const ChatAvatar = () => (
  <Flex
    flexShrink={0}
    w="26px"
    h="26px"
    borderRadius="full"
    bg={CHAT_COLORS.brand}
    color="white"
    fontSize="11px"
    fontWeight="700"
    letterSpacing="0.02em"
    align="center"
    justify="center"
    aria-hidden="true"
  >
    AI
  </Flex>
);
